var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"community-page"},[_c('h2',[_vm._v("Community")]),_c('v-row',_vm._l((_vm.reviewerList),function(user){return _c('review-card',{key:user.id,attrs:{"user":user}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }